import { render, staticRenderFns } from "./AttendanceOffer.vue?vue&type=template&id=4be3f59a"
import script from "./AttendanceOffer.vue?vue&type=script&lang=js"
export * from "./AttendanceOffer.vue?vue&type=script&lang=js"
import style0 from "./AttendanceOffer.vue?vue&type=style&index=0&id=4be3f59a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QLayout,QPageContainer,QPage,QTooltip});
